<template>
  <qrs />
</template>
<script>
import '@telexpress_auth/vue-qrs/dist/components/qrs.css';
import qrs from '@telexpress_auth/vue-qrs/dist/components/qrs.umd.min';

export default {
  components: {
    qrs,
  },
};
</script>
